<template>
  <div>
      <v-toolbar dense
                 src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg"
      >
        <v-spacer></v-spacer>
        <v-dialog
          v-model="dialog"
          width="800"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="white"
              outlined
              dark
              v-bind="attrs"
              v-on="on"
              @click="editedItem = defaultItem"
            >
              Instituce
            </v-btn>
          </template>
        <InstitutionForm
          v-if="dialog"
          :item="editedItem"
          @data-saved="getInstitutions"
          :districts="cityDistricts"
        ></InstitutionForm>
        </v-dialog>
      </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="institutions"
      sort-by="name"
      class="elevation-1"
      :search="search"
      :items-per-page="-1"
      locale="cs"
      :loading="loading"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Instituce</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-spacer>Výpis</v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Vyhledávání"
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          small
          class="mr-2"
          @click="$router.push({name: 'admin.institutionSettings', params: {id: item.id}})"
        >
          mdi-information-variant
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="getInstitutions">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import InstitutionForm from '../../components/forms/admin/InstitutionForm'
export default {
  Name: 'Institutions',
  components: { InstitutionForm },
  data: () => ({
    search: '',
    loading: true,
    dialog: false,
    editedItem: {},
    defaultItem: {
      id: null,
      name: '',
      deliveryPrice: '',
      minPrice: '',
      street: '',
      streetNumber: '',
      city: '',
      zip: '',
      cityDistrictId: null
    },
    cityDistricts: [],
    institutions: [],
    headers: [
      {
        text: 'Název instituce',
        align: 'start',
        sortable: true,
        value: 'name'
      },
      { text: 'Cena rozvozu', value: 'deliveryPrice' },
      { text: 'Minimální cena objednávky', value: 'minPrice' },
      { text: 'Ulice', value: 'street' },
      { text: 'č.p', value: 'streetNumber' },
      { text: 'Město', value: 'city' },
      { text: 'PSČ', value: 'zip' },
      { text: 'Telefon', value: 'phone1' },
      { text: 'Akce', value: 'actions', sortable: false }
    ]
  }),
  created () {
    this.$http.get('/admin/city-districts')
      .then(response => {
        this.cityDistricts = this.keysToCamelCase(response.data)
      })
      .catch(err => { console.log(err) })
    this.getInstitutions()
  },
  methods: {
    getInstitutions () {
      this.dialog = false
      this.loading = true
      this.$http.get('/admin/institutions')
        .then(response => {
          this.institutions = this.keysToCamelCase(response.data).map(inst => {
            inst.cityDistrictId = +inst.cityDistrictId
            return inst
          })
          this.loading = false
        })
        .catch(err => {
          console.log(err)
        })
    },
    editItem (item) {
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    toggleActive (item) {
      item.active = !item.active
      this.$http.patch(`/admin/institutions/${item.id}`, this.keysToSnakeCase(item))
        .then(response => {
          this.getInstitutions()
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>

<style scoped>

</style>
